import {
  Box,
  Button
} from '@mui/material';
import { useState } from 'react';
import FileUpload from '../Internal-Reports/FileUpload';

function DataUploaderComponent({ title, fileType }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;

    const parseFile = (file) => {
        const fileExtension = file.name.split('.').pop();
        if (['csv', 'xlsx', 'xls'].includes(fileExtension)) {
            setSelectedFile(file);
        } else {
            alert('Unsupported file format');
        }
    };

    const uploadFileToBackend = async () => {
        if (!selectedFile) {
            alert('Please select a file first.');
            return;
        }

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('type', fileType);
        try {
            const response = await fetch(`${apiUrl}/api/upload-data`, {
                method: 'POST',
                body: formData,
                credentials: 'include',
            });

            const result = await response.json();
            alert(result.message);
        } catch (error) {
            console.error('Error uploading file:', error);
            alert('Upload failed.');
        }
    };

    return (
        <Box sx={{ padding: 3, minHeight: '100vh', maxWidth: "100%", overflowX: "hidden" }}>
            <h2>Data Upload: {title} </h2>

            <div>
                <FileUpload onFileUpload={parseFile} />
                <Button
                    variant="contained"
                    sx={{ marginTop: 2 }}
                    onClick={uploadFileToBackend}
                >
                    Upload File
                </Button>
            </div>
        </Box>
    );
}

export default DataUploaderComponent;